module.exports = __webpack_public_path__ + "media/images/brands/logo_ekz_poweredby-54215aa1a292bf2d703e083ddc497ce6.svg";